import noPortalApiClient from 'hub-http/clients/noPortalApiClient';
import { getFlowKey } from '../routing/getFlowKey';
import { getParameter } from '../store/experiments/selectors';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
export const getExistingUserHubletChoice = state => {
  const ACQ0162Parameter = getParameter(state, ExperimentKeys.ACQ0162);
  const ACQ0157Parameter = getParameter(state, ExperimentKeys.ACQ0157);
  const experimentKeys = [`${ExperimentKeys.ACQ0162}-group-${ACQ0162Parameter}`, `${ExperimentKeys.ACQ0157}-group-${ACQ0157Parameter}`];
  return noPortalApiClient.post('signup/v1/location/existing-user-available-hublets', {
    data: {
      flowKey: getFlowKey(),
      experimentKeys
    }
  });
};